import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { baht, itemTitle, overallPct, turnHeadline, useTurnStatus } from "./turnStatusLogic";

// แถบเตือนติดเทิร์น (นีออน) — วงแหวนความคืบหน้า + ชิปโบนัสที่ค้าง · มีชิปเกิน 3 ก้อนกด "ดูทั้งหมด"
export default function TurnBar({ balance, path }) {
  const { status } = useTurnStatus(`${balance}|${path}`);
  const nav = useNavigate();
  const [all, setAll] = useState(false);
  const head = turnHeadline(status);
  if (!head || path === "/auth") return null;
  const pct = overallPct(status);
  const pending = status.items.filter((i) => i.remaining > 0);
  const shown = all ? pending : pending.slice(0, 3);
  return (
    <div className="tbn" role="status" aria-live="polite">
      <div className="tbn-ring" style={{ "--p": pct }} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} aria-label="ความคืบหน้าเทิร์น">
        <Icon icon="solar:lock-keyhole-minimalistic-bold-duotone" width={18} />
        <b>{pending.length ? `${pct}%` : "…"}</b>
      </div>
      <div className="tbn-body">
        <div className="tbn-title">{head.title}</div>
        <div className="tbn-detail">{head.detail}</div>
        {pending.length > 0 && (
          <div className="tbn-chips">
            {shown.map((it) => (
              <span key={`${it.src}-${it.since}-${it.amount}`} className="tbn-chip" title={`${itemTitle(it)} · แทงแล้ว ${baht(it.done)} จาก ${baht(it.required)}`}>
                <span className="tbn-chip-name">{itemTitle(it)}</span>
                <span className="tbn-chip-bar" aria-hidden="true">
                  <i style={{ width: `${Math.max(it.pct, 4)}%` }} />
                </span>
                <span className="tbn-chip-left">เหลือ {baht(it.remaining)}</span>
              </span>
            ))}
            {pending.length > 3 && (
              <button type="button" className="tbn-chip tbn-chip-more" onClick={() => setAll((v) => !v)}>
                {all ? "ย่อ" : `ดูทั้งหมด +${pending.length - 3}`}
              </button>
            )}
          </div>
        )}
      </div>
      <div className="tbn-side">
        <div className="tbn-side-row">
          <span>ถอนได้</span>
          <b>{baht(head.withdrawable)}</b>
        </div>
        <button type="button" className="tbn-go" onClick={() => nav("/")}>
          <Icon icon="solar:ticket-bold-duotone" width={16} />
          แทงหวยเลย
        </button>
      </div>
    </div>
  );
}
